import mediaApi from "./media.api";
import media from "./media.slice";

export default {
  media,
  [mediaApi.reducerPath]: mediaApi.reducer,
};
